import { Button, Input, Select, Switch } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomUploader from "../../../components/CustomUpload/CustomUploader";
import TextArea from "antd/es/input/TextArea";
import {
  CheckOutlined,
  CloseOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getStaticExpertFields } from "../../../service/api";
import SkeletonImage from "antd/es/skeleton/Image";
import { createCategory, createGoods } from "../../../service/shopApi";
import FileKeysContext from "../../../context/fileKeysContext";

function Category({
  shopData,
  setNewCategory,
  setNewGoods,
}) {
  const { shopImagesKeys, resetFileKeysContext } = useContext(FileKeysContext);
  const categoryQuery = useQueryClient();
  const [clearList, setClearList] = useState();
  const [saleable, setSaleable] = useState(true);
  const [color, setColor] = useState("color5");
  const [categoryId, setCategoryId] = useState();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const goodMutation = useMutation(createGoods, {
    onSuccess: () => {
      categoryQuery.invalidateQueries(["expertShop"]);
      setTitle("");
      setDescription("");
      setCategoryId();
      resetFileKeysContext();
      setClearList(true);
    },
  });
  const categoryMutation = useMutation(createCategory, {
    onSuccess: (data) => {
      const catId = data?.result?.data?.category?.id;
      goodMutation.mutate({
        title: title,
        saleable: saleable,
        description: description,
        categoryId: catId,
        images: shopImagesKeys,
      });

      setCategoryId();
      setColor("color5");
      setSaleable(true);
      setNewGoods(false);
    },
  });
  const titleRef = useRef();

  const staticsExpertFieldsQuery = useQuery(
    ["staticsExpertFields"],
    getStaticExpertFields
  );
  const expertCategories = shopData?.categories;
  const expertShopCategories =
    staticsExpertFieldsQuery?.data?.EXPERT_SHOP_CATEGORIES;

  let selectedCategories = [];
  expertCategories?.map((data) => {
    return selectedCategories.push(data?.typeId);
  });
  let remainCategories = [];
  expertShopCategories?.map((item) => {
    if (!selectedCategories.includes(item?.id)) {
    return  remainCategories.push(item);
    }
  });

  const options = remainCategories?.map((data) => {
    return {
      label: data?.title,
      value: data?.id,
    };
  });

  useEffect(() => {
    if (shopData?.categories.length === 0) {
      setNewCategory(true);
    } else {
      setNewCategory(false);
    }
  });

  return (
    <div className={`h-full  ${color} flex flex-row max-lg:flex-col gap-3 p-3`}>
      <div className="flex flex-col max-lg:flex-row max-lg:w-full gap-3 max-lg:gap-1 w-[20%] max-lg:justify-between ">
        <section className="bg-white rounded-lg p-3 max-lg:gap-2 flex flex-col gap-5 text-right">
          <div className="flex flex-col gap-3  max-lg:gap-2 max-lg:w-[40vw]">
            <label className="max-lg:text-[13px]">عنوان دسته بندی:</label>
            <Select
              value={categoryId}
              onSelect={(e) => setCategoryId(e)}
              options={options}
              placeholder="انتخاب کنید"
              size="middle"
              style={{ fontSize: "4px" }}
              className="w-full g max-lg:!text-[10px] text-center "
            />
          </div>
          <div className="items-start text-right flex flex-col gap-5  max-lg:gap-2">
            <label className="max-lg:text-[13px]">تصویر دسته بندی:</label>
            {categoryId ? (
              <div className="w-[11rem] h-[7rem] max-lg:w-[100px] max-lg:h-[100px] overflow-clip rounded-lg shadow-2xl max-lg:mx-auto ">
                <img
                  className="w-full h-full "
                  src={
                    process.env.REACT_APP_ARVAN_S3_BASE_URL +
                    remainCategories?.find((data) => data?.id === categoryId)
                      ?.cover
                  }
                  alt="coverImage"
                />
              </div>
            ) : (
              <div className="m-auto">
                <SkeletonImage />
              </div>
            )}
          </div>
        </section>
        <section className="bg-white p-3 max-lg:px-2 flex flex-col gap-6 rounded-lg  h-full max-lg:h-full max-lg:w-[36vw] max-lg:text-right">
          <label className="text-right whitespace-nowrap max-lg:text-[13px] ">
            رنگ زمینه دسته بندی:
          </label>

          <div className="flex flex-col max-lg:flex-row gap-4 max-lg:h-full max-lg:justify-around max-lg:py-[5px]">
            <section className="flex flex-row max-lg:flex-col justify-between max-lg:justify-evenly max-lg:gap-6">
              <div
                onClick={() => setColor("color1")}
                className={
                  color === "color1"
                    ? "w-8 h-8 rounded-full color1 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color1 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => setColor("color2")}
                className={
                  color === "color2"
                    ? "w-8 h-8 rounded-full color2 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color2 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => setColor("color3")}
                className={
                  color === "color3"
                    ? "w-8 h-8 rounded-full color3 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color3 cursor-pointer hover:brightness-125"
                }
              />
            </section>
            <section className="flex flex-row max-lg:flex-col justify-between">
              <div
                onClick={() => setColor("color4")}
                className={
                  color === "color4"
                    ? "w-8 h-8 rounded-full color4 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color4 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => setColor("color5")}
                className={
                  color === "color5"
                    ? "w-8 h-8 rounded-full color5 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color5 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => setColor("color6")}
                className={
                  color === "color6"
                    ? "w-8 h-8 rounded-full color6 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color6 cursor-pointer hover:brightness-90"
                }
              />
            </section>
          </div>
        </section>
      </div>
      <section className="bg-white w-[70%] rounded-lg gap-3 flex flex-row max-lg:flex-col ">
        <div className="flex flex-col max-lg:flex-col-reverse justify-between w-[55%] max-lg:w-full p-3 h-full max-lg:gap-4">
          <div className="flex flex-col text-right  ">
            <label className="max-lg:text-[13px]">تصویر محصول:</label>
            <div className="max-lg:h-[120px] overflow-y-scroll max-lg:w-full text-center">
              {
                <CustomUploader
                  type="shop-image"
                  clearList={clearList}
                  setClearList={setClearList}
                />
              }
            </div>
          </div>
          <div className="flex flex-col max-lg:flex-row gap-16 max-lg:gap-2">
            <div className="flex flex-col text-right gap-5 max-lg:gap-2">
              <label className="max-lg:text-[13px]">عنوان محصول:</label>
              <Input
                className="max-lg:text-xs"
                placeholder="عنوان محصول خود را وارد کنید"
                ref={titleRef}
                allowClear
                status={title.length === 0 ? "error" : ""}
                maxLength={51}
                required={true}
                onChange={(e) => setTitle(e.target.value)}
                value={title}
              />
            </div>
            <div className="flex flex-row max-lg:flex-col whitespace-nowrap items-center justify-between">
              <label className="max-lg:text-[13px]">وضعیت محصول:</label>
              <div className="max-lg:mx-auto max-lg:my-1">
                <Switch
                  checkedChildren={"موجود"}
                  unCheckedChildren={"ناموجود"}
                  onChange={(e) => setSaleable(e)}
                  className=" bg-red-500 :!bg-green-400 hover:bg-pink-300 !font-body  "
                  defaultChecked={true}
                  value={saleable}
                />
              </div>
            </div>
          </div>
        </div>
        <div className=" bg-[#F5F5F5] shadow-inner flex flex-col p-3 w-[50%] max-lg:w-full h-full justify-between rounded-r-xl rounded-l-lg">
          <div className="text-right flex flex-col gap-3">
            <label className="max-lg:text-[13px]">توضیحات محصول:</label>
            <TextArea
              status={description.length === 0 ? "error" : ""}
              onChange={(e) => setDescription(e.target.value)}
              className="!font-body"
              maxLength={400}
              value={description}
              allowClear
              showCount
              autoSize={{ minRows: 8, maxRows: 10 }}
              placeholder="توضیحات خود را وارد کنید..."
            />
          </div>
          <div className="flex flex-row justify-end gap-5 max-lg:mt-5">
            <Button
              loading={categoryMutation.isLoading}
              danger
              className="w-[130px]"
              type="primary"
              icon={<CloseOutlined />}
              onClick={() => setNewGoods(false)}
            >
              لغو
            </Button>
            <Button
              loading={categoryMutation.isLoading}
              onClick={() => {
                categoryMutation.mutate({
                  typeId: categoryId,
                  themeId: JSON.parse(color.replace("color", "")),
                });
              }}
              disabled={
                title.length > 3 && description.length > 2 ? false : true
              }
              type="primary"
              className="bg-[#005AC8] w-[130px]"
              icon={<CheckOutlined />}
            >
              ثبت محصول
            </Button>
          </div>
        </div>
      </section>
      <section className=" flex flex-col rotate-[270deg] max-lg:rotate-0 w-[50px] justify-center items-center text-center mx-auto my-auto whitespace-nowrap ">
        <PlusCircleOutlined className="text-white rounded-full text-4xl opacity-50" />
        <p className="text-white text-lg opacity-50">افزودن محصول جدید</p>
      </section>
    </div>
  );
}

export default Category;
